import styled from 'styled-components';

export const H1 = styled.h1`
  margin: 0 0 16px;
  font-size: 2em;

  small {
    font-weight: 400;
  }
`;

export const H2 = styled.h2`
  margin: 0 0 16px;
  font-size: 1.75em;
  color: #828e97;

  small {
    font-weight: 400;
  }
`;
export const H3 = styled.h3`
  margin: 0 0 16px;
  font-size: 1.5em;
  color: #828e97;

  small {
    font-weight: 400;
  }
`;
export const H4 = styled.h4`
  margin: 0 0 16px;
  font-size: 1.375em;
  color: #828e97;

  small {
    font-weight: 400;
  }
`;
export const H5 = styled.h5`
  margin: 0 0 14px;
  font-size: 1.25em;
  color: #828e97;

  small {
    font-weight: 400;
  }
`;
export const H6 = styled.h6`
  margin: 0 0 14px;
  font-size: 1em;
  color: #828e97;

  small {
    font-weight: 400;
  }
`;

type IParagraph = {
  display?: string;
};

export const Paragraph = styled.p<IParagraph>`
  line-height: 1.2;
  font-size: 0.95rem;

  .text-muted {
    color: ${props => props.theme.body.textMuted};
  }

  a {
    color: ${props => props.theme.linkColor};
    &:hover {
      color: ${props => props.theme.linkHoverColor};
    }
  }
`;
